import { render, staticRenderFns } from "./hqglMailSendAudit.vue?vue&type=template&id=54a49aa5&scoped=true&"
import script from "./hqglMailSendAudit.vue?vue&type=script&lang=js&"
export * from "./hqglMailSendAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a49aa5",
  null
  
)

export default component.exports